import React, { useState, useEffect } from 'react';

import { ALERT_TYPE, OPERATION_MODE, REQUEST_METHOD, ShowToastMessage } from '@laramie/ui';
import { APIS } from '../../config/apis';
import { ServerRequest } from '../../utils/apiweb';
import { APPCONFIG } from '../../app.config';
import { useAccess, useForm, useLista, useNav, useReporte } from '../../components/hooks';
import { OpenObjectURL } from '../../utils/helpers';
import { Loading, TableCustom, SectionHeading, InputPersona } from '../../components/common';
import DataTaggerModalApi from '../../components/controls/DataTaggerModalApi';
import DeclaracionesJuradasPendientesModal from '../../components/controls/DeclaracionesJuradasPendientesModal';

import './index.scss';
import { useLocation } from 'react-router-dom';
import { openTempView } from '../../utils/openTempView';
import {TIPS} from "../../consts/tips";

function ContribuyentesView() {

    //hooks
    const navigate = useNav()
    const location = useLocation()

    const [state, setState] = useState({
        loading: false,
        dataTagger: {
            showModal: false,
            entidad: '',
            idEntidad: null,
            registro: ''
        },
        ddjjPendientes: {
            showModal: false,
            idCuenta: null,
            numeroCuenta: ''
        },
        list: []
    });

    const [contribuyente, setContribuyente] = useState(0);

    const [ generateReporte, ] = useReporte({
        callback: (reporte, buffer, message) => {
            if (buffer)
                OpenObjectURL(`${reporte}.pdf`, buffer);
            else
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        }
    });

    const [ formValues, formHandle, formReset , formSet ] = useForm({
        idPersona: 0,
        descPersona: '', //no existe como control, se usa para tomar el text de idPersona
        numeroCuenta: '',
        numeroWeb: '',
        idTipoTributo: 0,
        cuenta: {
            id: 0,
            idTipoTributo: 0,
            numeroCuenta: '',
            numeroWeb: '',
            idContribuyente: '',
            idTipoDocumentoContribuyente: 0,
            numeroDocumentoContribuyente: '',
            nombreContribuyente: '',
            detalleTributo: '',
            idEstadoCuenta: 0
        },
        etiqueta: ''
        
    });

    useEffect(() => {

        if (formValues.idPersona > 0) {
            SearchContribuyentes();
        }
        else
        {
            setState(prevState => {
                return {...prevState, list: []};
            });
        }
   
    }, [formValues.idPersona]);

    const [, getRowLista ] = useLista({
        listas: ['TipoTributo', 'EstadoCuenta'],
        onLoaded: (listas, isSuccess, error) => {
          if (!isSuccess) {
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
          }
        },
        memo: {
          key: 'TipoTributo_EstadoCuenta',
          timeout: 0
        }
    });

    const getDescTipoTributo = (id) => {
        const row = getRowLista('TipoTributo', id);
        return (row) ? row.nombre : '';
    }

    const getDescEstadoCuenta = (id) => {
        const row = getRowLista('EstadoCuenta', id);
        return (row) ? row.nombre : '';
    }

    // Texto y no elementos: el buscador de la tabla y el CSV leen lo que devuelve la celda.
    // Sin el campo (una API anterior) no se afirma nada; «Sin vínculo» es sólo una lista vacía.
    const getDescVinculos = (vinculos) => {
        if (!vinculos) return '';
        return (vinculos.length > 0)
            ? vinculos.map(x => (x.deBaja) ? `${x.tipoVinculo} (de baja)` : x.tipoVinculo).join(', ')
            : 'Sin vínculo';
    }

    const [hasEditAccess, setHasEditAccess] = useState(false)
    const [tableVisible, setTableVisible] = useState(false)

    useAccess({
        key: 'ContribuyentesView',
        onLoaded: (data, isSuccess, error) => {
            if (!isSuccess) ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error)
            else setHasEditAccess(data.some(x => x.codigo === 'cuenta_edit'))
        }
    })

    //definiciones
    const cellVMR = (props) =>  <div className='action'>
                                    <div onClick={ (event) => handleClickTributoView(props) } className="link">
                                        <span className="material-symbols-outlined" title="Ver">search</span>
                                    </div>
                                    <div onClick={ (event) => handleClickContribuyenteDataTagger(props) } className="link">
                                        <span className="material-symbols-outlined" title="Información adicional">info</span>
                                    </div>
                                    <div onClick={ (event) => handleClickCtaCteCuenta(props.value) } className="link">
                                        <span className="material-symbols-outlined" title="Cuenta corriente">calculate</span>
                                    </div>
                                    <div onClick={(event) => handleClickDeuda(props.value)} className="link" style={{ visibility: props.row.original.tieneDeuda ? 'visible' : 'hidden'}}>
                                        <span className="material-symbols-outlined" title="Deuda">attach_money</span>
                                    </div>
                                    <div onClick={(event) => handleClickDdjjNoPresentadas(props)} className="link" style={{ visibility: props.row.original.tieneDdjjsPendientes ? 'visible' : 'hidden'}}>
                                        <span className="material-symbols-outlined" title="DDJJ no presentadas">assignment_late</span>
                                    </div>
                                </div>
    const tableColumns = [
        { Header: 'N° Cuenta', accessor: 'numeroCuenta', width: '12%' },
        { Header: 'Tipo de tributo', Cell: (data) => getDescTipoTributo(data.value), accessor: 'idTipoTributo', width: '14%' },
        { Header: 'Detalle', accessor: 'detalleTributo', width: '30%' },
        { Header: 'Vínculo', Cell: (data) => getDescVinculos(data.value), accessor: 'vinculos', width: '20%',
          sortType: (rowA, rowB) => getDescVinculos(rowA.original.vinculos).localeCompare(getDescVinculos(rowB.original.vinculos)) },
        { Header: 'Estado cuenta', Cell: (data) => getDescEstadoCuenta(data.value), accessor: 'idEstadoCuenta', width: '12%' },
        { Header: '', Cell: cellVMR, id:'abm', accessor: 'id', width: '12%', disableGlobalFilter: true, disableSortBy: true },
    ];

    // Handlers
    const handleClickTributoView = (props) => {

        const row = props.row.original;
        
        let tipoTributo = '';
        
        switch (row.idTipoTributo) {
            case 10:
                tipoTributo = '/inmueble/';
                break;
            case 11:
                tipoTributo = '/comercio/';
                break;
            case 12:
                tipoTributo = '/vehiculo/';
                break;
            case 13:
                tipoTributo = '/cementerio/';
                break;
            case 14:
                tipoTributo = '/fondeadero/';
                break;
            case 15:
                tipoTributo = '/cuenta-especial/';
                break;
        
            default:
                break;
        }

        navigate({ to: `${tipoTributo}view/${row.idTributo}` });
    }
    const handleClickContribuyenteDataTagger = (props) => {
        const row = props.row.original;
        const entidad = GetEntidad(row.idTipoTributo);
        setState(prevState => {
          return {...prevState, dataTagger: {showModal: true, entidad: entidad, idEntidad: row.idTributo, registro: `la cuenta ${row.numeroCuenta}`}};
        });
    }
    const handleClickCtaCteContribuyente = () => {
        const url = APPCONFIG.SITE.WEBAPP + 'cuenta-corriente/contribuyente/' + OPERATION_MODE.VIEW + '/' + contribuyente;
        window.open(url, '_blank');
    }
    const handleClickInformeDeudaContribuyente = () => {
        generateReporte("ContribuyenteInformeDeuda", { idContribuyente: contribuyente });
    }
    const handleClickCtaCteCuenta = (idCuenta) => {
        const url = APPCONFIG.SITE.WEBAPP + 'cuenta-corriente/cuenta/' + OPERATION_MODE.VIEW + '/' + idCuenta;
        window.open(url, '_blank');
    }

    const handleClickDeuda = (idCuenta) => {
        openTempView(`${APPCONFIG.SITE.WEBAPP}deuda/${OPERATION_MODE.VIEW}/${idCuenta}`);
    }

    const handleClickDdjjNoPresentadas = (props) => {
        const row = props.row.original;
        setState(prevState => {
            return {...prevState, ddjjPendientes: {showModal: true, idCuenta: row.id, numeroCuenta: row.numeroCuenta}};
        });
    }

    // Callbacks
    const callbackNoSuccess = (response) => {
        response.json()
        .then((error) => {
          const message = error.message;
          ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
          setState(prevState => {
            return {...prevState, loading: false};
          });
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
              return {...prevState, loading: false};
            });
        });
    }
    const callbackError = (error) => {
        const message = 'Error procesando solicitud: ' + error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setState(prevState => {
          return {...prevState, loading: false};
        });
    }

    // Functions

    function SearchContribuyentes() {

        setState(prevState => {
            return {...prevState, loading: true, list: []};
        });

        const callbackSuccess = (response) => {
            response.json()
            .then((data) => {
                setContribuyente(data.id);
                SearchCuentas(data.id);
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            });
        };

        let paramsUrl = `/persona/${formValues.idPersona}`;
        
        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.CONTRIBUYENTE,
            paramsUrl,
            null,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );

    }

    function SearchCuentas(idContribuyente) {

        setState(prevState => {
            return {...prevState, loading: true, list: []};
        });

        const callbackSuccess = (response) => {
            response.json()
            .then((data) => {
                setState(prevState => {
                    return {...prevState, loading: false, list: data};
                });
                setTableVisible(true);
                if (!data?.length) ShowToastMessage(ALERT_TYPE.ALERT_WARNING, 'La persona no tiene tributos asociados');
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            });
        };

        let paramsUrl = `/contribuyente/`+
        `${idContribuyente}`;
        

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.CUENTA,
            paramsUrl,
            null,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );

    }

    function GetEntidad(idTipoTributo) {
        let entidad = '';
            
        switch (idTipoTributo) {
            case 10:
                entidad = 'Inmueble';
                break;
            case 11:
                entidad = 'Comercio';
                break;
            case 12:
                entidad = 'Vehiculo';
                break;
            case 13:
                entidad = 'Cementerio';
                break;
            case 14:
                entidad = 'Fondeadero';
                break;
            case 15:
                entidad = 'Especial';
                break;
        
            default:
                break;
        }
    
        return entidad;
    }

    return (
    <>

        <Loading visible={state.loading}></Loading>

        {state.dataTagger.showModal &&
            <DataTaggerModalApi
                title="Información adicional de tributo"
                registro={state.dataTagger.registro}
                tipName={TIPS.NAME.MODALS.INFORMACION_ADICIONAL_TRIBUTO_MODAL}
                entidad={state.dataTagger.entidad}
                idEntidad={state.dataTagger.idEntidad}
                disabled={!hasEditAccess}
                onConfirm={() => {
                    setState(prevState => {
                        return {...prevState, dataTagger: {showModal: false, entidad: '', idEntidad: null, registro: ''}};
                    });
                }}
                onDismiss={() => {
                    setState(prevState => {
                        return {...prevState, dataTagger: {showModal: false, entidad: '', idEntidad: null, registro: ''}};
                    });
                }}
            />
        }

        {state.ddjjPendientes.showModal &&
            <DeclaracionesJuradasPendientesModal
                idCuenta={state.ddjjPendientes.idCuenta}
                numeroCuenta={state.ddjjPendientes.numeroCuenta}
                onDismiss={() => {
                    setState(prevState => {
                        return {...prevState, ddjjPendientes: {showModal: false, idCuenta: null, numeroCuenta: ''}};
                    });
                }}
            />
        }

        {location.pathname.length > 1 && <SectionHeading titles={[{ title: 'Tributos' }, { title: 'Consulta por contribuyente' }]} />}

        <section className='section-accordion'>

            <div className='contribuyente'>
                <div className="col-12">
                    <div className='accordion-header'>
                        <div className='row'>
                            <div className="col-12">
                                <div className='accordion-header-title m-left-20'>
                                    <span className='active'>Contribuyente</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='accordion-body'>
                        <div className='row'>
                            <div className="col-12 col-md-6 col-lg-4">
                                <InputPersona
                                    name="idPersona"
                                    placeholder="Seleccione un contribuyente"
                                    className="form-control"
                                    value={ formValues.idPersona }
                                    idTipoPersona={0}
                                    onChange={({target}) =>{
                                        let idPersona = 0;
                                        let descPersona = '';
                                        if (target.row) {
                                            idPersona = parseInt(target.value);
                                            descPersona = target.row.nombrePersona;
                                        }
                                        else {
                                            setContribuyente(0);
                                        }
                                        formSet({...formValues, idPersona: idPersona, descPersona: descPersona});
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {tableVisible && (
                <TableCustom
                    className={'TableCustomBase m-top-20'}
                    columns={tableColumns}
                    data={state.list}
                    messageEmpty="No se encontraron resultados"
                />
            )}

        </section>
        {contribuyente > 0 &&
        <footer className='footer footer-action'>
            <div className='footer-action-container'>
                
                <button className="btn back-button float-end" onClick={ (event) => handleClickCtaCteContribuyente() }>Cuenta corriente</button>
                <button className="btn back-button float-end m-right-5" onClick={ (event) => handleClickInformeDeudaContribuyente() }>Informe Deuda</button>
            </div>
        </footer>
                }
        
    </>
    )
}

export default ContribuyentesView;
